import type { HistoryType } from '../../../entities/consignments/model/types';

/**
 * Lookup table to determine the history type based on the combination of filters.
 * The keys are formed by concatenating the boolean values of showStatus and showPriority.
 * For example:
 * - '00' means both filters are false, resulting in undefined (no specific type).
 * - '01' means showStatus is false and showPriority is true, resulting in 'PRIORITY'.
 * - '10' means showStatus is true and showPriority is false, resulting in 'STATUS'.
 * - '11' means both filters are true, resulting in 'ALL'.
 */
export const HISTORY_TYPE_LOOKUP = {
  '00': undefined,
  '01': 'PRIORITY',
  '10': 'STATUS',
  '11': 'ALL'
} as const satisfies Record<string, HistoryType | undefined>;

export type HistoryTypeLookupKey = keyof typeof HISTORY_TYPE_LOOKUP;
